import { render } from "./edit-billing-details.vue?vue&type=template&id=c4af16d0"
import script from "./edit-billing-details.vue?vue&type=script&lang=js"
export * from "./edit-billing-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__